import Error from "../../components/Error";

const ErrorPage = () => {
  return <Error></Error>;
};

export default ErrorPage;
